<template>
  <div class="select-container">
    <Dropdown
      v-if="paramData.options"
      class="select-container__select"
      :id="paramData.name + optionNumber"
      v-model="inputText[paramIndex]"
      :options="paramData.options"
      :placeholder="paramData.label"
      :filter="true"
      @change="actionConstructor(inputText[paramIndex], paramData.name, paramData.fieldType)"
    />
    <input v-else
      class="input-container__input"
      :name="paramData.name + optionNumber"
      type="text"
      :placeholder="paramData.label"
      :id="paramData.name + optionNumber"
      v-model="inputText[paramIndex]"
      @keydown.tab="actionConstructor(inputText[paramIndex], paramData.name, paramData.fieldType)"
      @blur="actionConstructor(inputText[paramIndex], paramData.name, paramData.fieldType)"
    />
  </div>
</template>

<script>
export default {
  name: "Select",
  props: {
    optionNumber: {
      type: Number,
      required: false,
    },
    paramData: {
      type: Object,
      required: false,
    },
    paramIndex: {
      type: Number,
      required: false,
    },
    inputText: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {
    actionConstructor(text, name, type) {
      this.$emit("actionConstructor", text, name, type);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-container {
  margin: 0 .5rem;
  &__input {
    margin: 5px 0;
    background-color: #f3f3f3;
    border: solid 1px #d9d9d9;
    padding-left: 5px;
    color: #495057;
    height: 33px;
  }
  &__select {
    margin: 5px 0;
    background-color: #f3f3f3;
    border: solid 1px #d9d9d9;
    color: #495057;
    height: 33px;
    border-radius: 0;
  }
}
</style>
